import { createBrowserRouter, Navigate } from 'react-router-dom';
import { Login } from './pages/Login';
import { Signup } from './pages/Signup';
import SendResetPasswordEmail from './pages/SendResetPasswordEmail';
import ResetPasswordEmail from './pages/ResetPasswordEmail';
import { AdminLayout } from './layouts/AdminLayout';
import { EmployeeLayout } from './layouts/EmployeeLayout';
import { ProtectedRoute } from './components/ProtectedRoute';
import { DashboardPage } from './pages/employee/Dashboard';
import { MyCoursesPage } from './pages/employee/MyCourses';
import { MyCertificatesPage } from './pages/Certificate';
import { CourseViewPage } from './pages/employee/CourseViewPage';
import { AdminDashboard } from './pages/Admin/AdminDashboard';
import { AdminEmployeePage } from './pages/Admin/AdminEmployeePage';
import { AdminEmployeeDetailPage } from './pages/Admin/AdminEmployeeDetailPage';
import { AdminCertificatesPage } from './pages/Admin/AdminCertificatesPage';
import { AdminCoursesPage } from './pages/Admin/AdminCoursesPage';
import { AdminTranscriptsPage } from './pages/Admin/AdminTranscriptsPage';
import { ProfilePage } from './pages/ProfilePage';
import { DisabledAccount } from './pages/DisabledAccount';
import { ErrorPage } from './components/ErrorPage';

export const router = createBrowserRouter([
    {
        path: '/',
        errorElement: <ErrorPage />,
        children: [
            {
                path: 'login',
                element: <Login />
            },
            {
                path: 'signup',
                element: <Signup />
            },
            {
                path: 'send-reset-password-email',
                element: <SendResetPasswordEmail />
            },
            {
                path: 'reset-password',
                element: <ResetPasswordEmail />
            },
            {
                path: 'disabled-account',
                element: <DisabledAccount />
            },
            {
                path: 'admin',
                element: <ProtectedRoute requiredRole="admin"><AdminLayout /></ProtectedRoute>,
                errorElement: <ErrorPage />,
                children: [
                    {
                        index: true,
                        element: <AdminDashboard />
                    },
                    {
                        path: 'employees',
                        element: <AdminEmployeePage />
                    },
                    {
                        path: 'employees/:employeeId',
                        element: <AdminEmployeeDetailPage />
                    },
                    {
                        path: 'courses',
                        element: <AdminCoursesPage />
                    },
                    {
                        path: 'certificates',
                        element: <AdminCertificatesPage />
                    },
                    {
                        path: 'transcripts',
                        element: <AdminTranscriptsPage />
                    },
                    {
                        path: 'profile',
                        element: <ProfilePage />
                    }
                ]
            },
            {
                path: '',
                element: <ProtectedRoute><EmployeeLayout /></ProtectedRoute>,
                errorElement: <ErrorPage />,
                children: [
                    {
                        index: true,
                        element: <Navigate to="dashboard" replace />
                    },
                    {
                        path: 'dashboard',
                        element: <DashboardPage />
                    },
                    {
                        path: 'courses',
                        element: <MyCoursesPage />
                    },
                    {
                        path: 'certificates',
                        element: <MyCertificatesPage />
                    },
                    {
                        path: 'courses/:id',
                        element: <CourseViewPage />
                    },
                    {
                        path: 'profile',
                        element: <ProfilePage />
                    }
                ]
            }
        ]
    }
]); 